import { render, staticRenderFns } from "./HomePageContentBrussel.vue?vue&type=template&id=55e5dcdf&scoped=true"
import script from "./HomePageContentBrussel.vue?vue&type=script&lang=ts"
export * from "./HomePageContentBrussel.vue?vue&type=script&lang=ts"
import style0 from "./HomePageContentBrussel.vue?vue&type=style&index=0&id=55e5dcdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e5dcdf",
  null
  
)

export default component.exports